var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 16,
    viewBox: "0 0 59 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73949 0H0.5V16H7.55924C8.82951 16 9.92813 15.7969 10.8551 15.3907C11.7992 14.9845 12.5287 14.4354 13.0437 13.7433C13.5587 13.0362 13.8162 12.2313 13.8162 11.3286C13.8162 10.11 13.3527 9.10202 12.4258 8.30465C12.0499 7.97523 11.6063 7.69775 11.0949 7.47222C11.4408 7.30338 11.7471 7.10695 12.0138 6.88293C12.8549 6.17583 13.2755 5.2882 13.2755 4.22003C13.2755 3.42266 13.0523 2.70804 12.606 2.07616C12.1597 1.44429 11.516 0.940292 10.6748 0.564176C9.85088 0.188059 8.87243 0 7.73949 0ZM6.91553 12.9986H5.03178V9.1622H6.91553C7.39617 9.1622 7.80815 9.24495 8.15146 9.41044C8.51195 9.56088 8.7866 9.78655 8.97542 10.0874C9.16425 10.3733 9.25866 10.7043 9.25866 11.0804C9.25866 11.6521 9.04409 12.1185 8.61494 12.4795C8.20296 12.8256 7.63649 12.9986 6.91553 12.9986ZM6.63229 6.25106H5.03178V3.00141H6.63229C7.23309 3.00141 7.72232 3.13681 8.09997 3.40762C8.49478 3.66338 8.69219 4.06958 8.69219 4.62623C8.69219 5.18289 8.49478 5.59662 8.09997 5.86742C7.72232 6.12318 7.23309 6.25106 6.63229 6.25106Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5415 0V16H26.9821V12.5924H20.1505V9.5007H25.0036V6.18336H20.1505V3.40762H26.8276V0H15.5415Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2623 16V3.47532H28.7264V0H42.4072V3.47532H37.8713V16H33.2623Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0418 0L39.9609 16H44.6729L45.7658 13.2017H52.635L53.685 16H58.5L51.4964 0H47.0418ZM51.4326 9.9972L49.2691 4.23131L47.0173 9.9972H51.4326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.1045ea727c97bad048de1ba3efdf9b7a.svg";
export { ForwardRef as ReactComponent };